import { inject } from "@angular/core";
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router, RouterStateSnapshot, UrlSegment } from "@angular/router";
import { LocalStorageService } from "../local-storage.service";
import { AppState } from "src/app/store/root.state";
import { Store } from "@ngrx/store";
import { AuthService } from "../auth.service";
import * as moduleActions from 'src/app/store/modules/modules.actions';
import * as _ from 'lodash';
import { first, take } from "rxjs";
import { RolesResponse } from "src/app/model/roles";

export const pageGuardInjectable = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {

    // inject the services you need
    const router: Router = inject(Router);
    const localStorageService: LocalStorageService = inject(LocalStorageService);
    const store: Store<AppState> = inject(Store<AppState>);
    const authService: AuthService = inject(AuthService);
    const activatedRoute: ActivatedRoute = inject(ActivatedRoute);

    let session = localStorageService.getSession();
    if (session == undefined) {
        console.error("User is not loged in !! How did you get here???");
        return router.navigate(['/auth/login']);
    }

    if (session!.id == 0) {
        console.error("Invalid user!");
        return router.navigate(['/auth/login']);
    }

    // page path
    //console.warn("THIS FROM URL IN AUTH");
    //console.warn(state);
    

    const urlSegments = state.url.split(';')[0].split('/');
    //console.warn("This tha url in array");
    //console.warn(urlSegments);

    let lastSegment = '';
    let url: string = "";
    // if it is a codice or a id in the url remove it and normalize the url
    for (let i = 0; i < urlSegments.length; i++) {
        if (urlSegments[i] === "") {
            continue;
        }
        /*if(urlSegments[i].includes('?')) {
            console.warn("\n \n \n \n SPLITTING URL \n \n \n \n");
            console.warn(urlSegments[i].split('?'));
            urlSegments[i] = urlSegments[i].split('?')[0];
        }*/
        let lastValue = urlSegments[i].slice(-1);
        lastSegment = urlSegments[i];
        // parse in a number
        const isNumber = parseInt(lastValue, 10);
        if (isNaN(isNumber)) {
            // not a number no need to alter this piece of string
            if (i != urlSegments.length - 1) {
                url = url + urlSegments[i] + "/";
            } else {
                url = url + urlSegments[i];
            }
        } else {
            // this a number add blankspace
            if (i != urlSegments.length - 1) {
                url = url + `{any}` + "/";
            } else {
                url = url + `{any}`;
            }
        }

    }

    //add if for every url where the {any} value isNaN 
    if ((urlSegments.includes('masterdata') || urlSegments.includes('user')) && urlSegments.includes('edit')) {
        console.error('MASTERDATA ')
        if(urlSegments.includes('modelli') && urlSegments.includes('listino')) {

        }else{
            url = url.replace(lastSegment, `{any}`);
        }        
    }

    if (urlSegments.includes('automezzi') && urlSegments.includes('edit')) {
        console.error('AUTOMEZZI')
        url = url.replace(urlSegments[5], `{any}`);
    }

    if (urlSegments.includes('articoli') && urlSegments.includes('edit')) {
        console.error('AUTOMEZZI')
        url = url.replace(urlSegments[5], `{any}`);
    }

    if(urlSegments.includes('masterdata') && urlSegments.includes('modelli')) {
        console.warn("\n \n THIS LITLE BITCH IS IN MASTERDATA MODELLI EDIT \n \n");
        if(typeof urlSegments[5] === 'undefined') {
            // does not exist            
        }
        else {
            // does exist
            url = url.replace(urlSegments[5], `{any}`);
        }        
    }

    console.warn("THIS THA EDITED URL");
    console.warn(url);

    // check if store has value JUST ONCE TOUGH
    store.select('modules').pipe(take(1)).subscribe(data => {
        // check if store has data
        if (data.route.length > 0) {
            console.log(data);
            // if it has use them
            // check if user have access to this page
            if (data.route.find(x => x.route.includes(url)) == undefined) {
                console.error("User cannot access this page: " + url);
                return router.navigate(['/error/unauthorized']);
            }
            return true;
        } else {
            // else get the data from API
            authService.getModulesRoute(session!.id).pipe(take(1)).subscribe({
                next: (dataApi: RolesResponse[]) => {
                    //console.warn("This is data API");
                    console.warn(dataApi);

                    // save the data in the store
                    store.dispatch(new moduleActions.GetRoutes({
                        route: dataApi,
                    }));

                    // check if user have access to this page
                    if (dataApi.find(a => a.route.includes(url)) == undefined) {
                        console.error("User cannot access this page: " + url);

                        return router.navigate(['/error/unauthorized']);
                    }

                    return true;
                },
                error: (response: any) => {
                    console.error("Cannot get the user data right now");
                    //return router.navigate(['/error']);
                }
            });
            return true;
        }
    });


    //console.warn("The user have access to this page");
    return true;

}
